import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class AuditMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AuditMetaModule,
            providers: [
                providePageMeta({
                    title: 'Audit',
                    translationKey: 'page_audit',
                    routerLink: '/audit',
                    icon: 'timeline',
                    permission: 'Audit.View',
                    type: 'Admin',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 4,
                }),
                providePageMeta({
                    title: 'Audit',
                    translationKey: 'page_audit',
                    routerLink: '/host/audit',
                    icon: 'timeline',
                    type: 'Sidebar',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                    priority: 3,
                }),
            ],
        };
    }
}
